import { render } from "./ProductLookup.vue?vue&type=template&id=2273922d&scoped=true"
import script from "./ProductLookup.vue?vue&type=script&lang=js"
export * from "./ProductLookup.vue?vue&type=script&lang=js"

import "./ProductLookup.vue?vue&type=style&index=0&id=2273922d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2273922d"]])

export default __exports__